export const SOUTH_AFRICA_TIME_ZONE = "Africa/Johannesburg";
